import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss']
})
export class InputFieldComponent {
  @Input() type: string;
  @Input() disabled: boolean;
  @Input() dynamicType: string;
  @Input() form: UntypedFormGroup;
  @Input() inputName: string;
  @Input() label: string;
  @Input() maxLength: string;
  @Input() minLength: string;
  @Input() placeholder: string;
  @Input() errorMessage: string;
  @Input() error: boolean;
  @Input() submitted: boolean;
  @Input() uppercase: boolean;
  @Input() tall = false;
  @Input() list: Array<string | Location>;
  @Input() autocomplete: string;
  @Input() patternKey: string;
  @Input() buttonPreview: boolean;
  @Input() value: number;
  @Input() isEmail: boolean;

  @Output() valueChange = new EventEmitter<boolean>();
  @Output() keyUp = new EventEmitter<boolean>();

  showInputText: boolean = false;

  getControl(): AbstractControl {
    return this.form.get(this.inputName);
  }

  handleKeypress(key: string): boolean {
    const pattern = new RegExp(this.patternKey);
    return pattern.test(key);
  }

  toggleTextPreview() {
    this.showInputText = !this.showInputText;
    this.showInputText ? (this.dynamicType = 'text') : (this.dynamicType = 'password');
  }
}
